import React from "react";
import {
  BORDER_RADIUS,
  COLORS,
  SPACING,
  TYPOGRAPHY,
} from "../../constants/theme";

export interface QuickActionButtonProps {
  label: string;
  icon: React.ReactNode;
  onClick: () => void;
  variant?: "primary" | "secondary";
  disabled?: boolean;
  style?: React.CSSProperties;
}

export const QuickActionButton: React.FC<QuickActionButtonProps> = ({
  label,
  icon,
  onClick,
  variant = "secondary",
  disabled = false,
  style,
}) => {
  const isPrimary = variant === "primary";

  return (
    <button
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: SPACING.sm,
        padding: "8px 18px",
        backgroundColor: isPrimary
          ? COLORS.primary.main
          : COLORS.background.primary,
        color: isPrimary ? "#ffffff" : COLORS.primary.main,
        border: isPrimary ? "none" : `1.5px solid ${COLORS.primary.main}`,
        borderRadius: BORDER_RADIUS.md,
        fontSize: TYPOGRAPHY.fontSize.sm,
        fontWeight: TYPOGRAPHY.fontWeight.semibold,
        cursor: disabled ? "not-allowed" : "pointer",
        opacity: disabled ? 0.5 : 1,
        transition: "all 0.15s ease",
        ...style,
      }}
      onMouseEnter={(e) => {
        if (!disabled) {
          e.currentTarget.style.backgroundColor = isPrimary
            ? COLORS.primary.dark
            : COLORS.primary.light;
        }
      }}
      onMouseLeave={(e) => {
        if (!disabled) {
          e.currentTarget.style.backgroundColor = isPrimary
            ? COLORS.primary.main
            : COLORS.background.primary;
        }
      }}
    >
      <span style={{ display: "flex", alignItems: "center" }}>{icon}</span>
      <span>{label}</span>
    </button>
  );
};
